import React from "react";
import { Box, Typography } from "@mui/material";
import { EggBadge } from "./homeUi";

export function HomeChallengeRow({ task, onClick }) {
  const claimed = Boolean(task.claimed);

  return (
    <Box
      onClick={onClick}
      sx={{
        display: "flex",
        alignItems: "center",
        minHeight: { xs: 56, md: 96 },
        px: { xs: "12px", md: "18px" },
        py: { md: 1.5 },
        bgcolor: "#15170F",
        border: "1px solid #262B1C",
        cursor: onClick ? "pointer" : "default",
      }}
    >
      <Box
        sx={{
          width: 20,
          height: 20,
          border: "1px solid #3A4030",
          bgcolor: "#0D0F0A",
          mr: "12px",
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {claimed ? (
          <Box
            component="span"
            sx={{
              color: "#B8EE3C",
              fontSize: 14,
              fontWeight: 700,
              lineHeight: 1,
            }}
          >
            ✓
          </Box>
        ) : null}
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          sx={{
            fontFamily: "'Poppins', sans-serif",
            fontSize: { xs: 13, md: 15 },
            color: "#F2FAE6",
            lineHeight: "18px",
          }}
        >
          {task.title}
        </Typography>
        {task.description ? (
          <Typography
            sx={{
              fontFamily: "'Poppins', sans-serif",
              fontSize: { xs: 11, md: 13 },
              color: "#9AA88A",
              lineHeight: "14px",
            }}
          >
            {task.description}
          </Typography>
        ) : null}
      </Box>
      <Typography
        sx={{
          fontFamily: "'Rajdhani', sans-serif",
          fontWeight: 700,
          fontSize: 12,
          color: "#B8EE3C",
          mr: "6px",
        }}
      >
        +{task.rewardEggs}
      </Typography>
      <EggBadge size={13} />
    </Box>
  );
}
